const avatarImage = require('./avatar.png')
const pagenotfound = require('./notfound.png')
const permissiondenied = require('./403.png')
const internalserver = require('./500.png')
const unauth = require('./401.png')
const nointernet = require('./nointernet.png')
const campxLogoPrimary = require('./campx_logo__full_primary.png')
const campxLogoSquare = require('./X.png')
const animatedImage = require('./animation.gif')
const activeDevices = require('./active_devices.svg')
const changePassword = require('./change_password.svg')
const clogWheel = require('./clog_wheel.svg')
const logoutIcon = require('./logout_icon.svg')
const notifications = require('./notifications.svg')
const profile = require('./profile.svg')
const web = require('./web.svg')
const mobile = require('./mobile.svg')
const location = require('./location.svg')
const noDevices = require('./no_devices.svg')
const careers = require('./lottery.svg')
export {
  activeDevices,
  animatedImage,
  avatarImage,
  campxLogoPrimary,
  campxLogoSquare,
  careers,
  changePassword,
  clogWheel,
  internalserver,
  location,
  logoutIcon,
  mobile,
  noDevices,
  nointernet,
  notifications,
  pagenotfound,
  permissiondenied,
  profile,
  unauth,
  web,
}
